import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
// Get environment variables - support both Expo and Vite
const getEnvVar = (expoKey, viteKey) => {
    // Check if we're in a browser environment (Vite)
    if (typeof window !== 'undefined') {
        // Browser environment - try Vite env vars
        try {
            // @ts-expect-error - import.meta is available in Vite
            const viteValue = import.meta.env?.[viteKey];
            if (viteValue)
                return viteValue;
        }
        catch (error) {
            // Only log in development
            if (process.env.NODE_ENV === 'development') {
                console.warn(`Failed to access import.meta.env.${viteKey}:`, error);
            }
        }
    }
    // Node.js environment (Expo) - use process.env
    return process.env[expoKey];
};
const firebaseConfig = {
    apiKey: getEnvVar('EXPO_PUBLIC_FIREBASE_API_KEY', 'VITE_FIREBASE_API_KEY'),
    authDomain: getEnvVar('EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN', 'VITE_FIREBASE_AUTH_DOMAIN'),
    projectId: getEnvVar('EXPO_PUBLIC_FIREBASE_PROJECT_ID', 'VITE_FIREBASE_PROJECT_ID'),
    storageBucket: getEnvVar('EXPO_PUBLIC_FIREBASE_STORAGE_BUCKET', 'VITE_FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: getEnvVar('EXPO_PUBLIC_FIREBASE_MESSAGING_SENDER_ID', 'VITE_FIREBASE_MESSAGING_SENDER_ID'),
    appId: getEnvVar('EXPO_PUBLIC_FIREBASE_APP_ID', 'VITE_FIREBASE_APP_ID'),
};
// Validate required fields
const requiredFields = ['apiKey', 'projectId', 'appId'];
const missingFields = requiredFields.filter(field => !firebaseConfig[field]);
if (missingFields.length > 0) {
    const error = `Firebase configuration is missing required fields: ${missingFields.join(', ')}\n` +
        'Please check your environment variables.';
    console.error('❌', error);
    throw new Error(error);
}
// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
/**
 * Admin API key for Cloud Function calls (setUserRole, seedMunicipalityRoles, etc.).
 * Must be set via VITE_ADMIN_API_KEY (or EXPO_PUBLIC_ADMIN_API_KEY for Expo).
 * Never commit the real value – use .env (gitignored).
 */
export const getAdminApiKey = () => getEnvVar('EXPO_PUBLIC_ADMIN_API_KEY', 'VITE_ADMIN_API_KEY');
// Expose fresh token getter for migration runbook (super-admin needs ID token). Safe: only returns current user's token.
if (typeof window !== 'undefined') {
    window.__getFirebaseAuthToken =
        async () => auth.currentUser?.getIdToken(true) ?? null;
}
export default app;
